import API from 'constants/API';

import {AxiosResponse} from 'axios';
import {AcceptInvitationDTO} from 'typescript/dto/acceptInvitationDTO';
import ApiData from 'typescript/interfaces/ApiData';
import DashboardData from 'typescript/models/AdminDashboardData';
import User from 'typescript/models/User';
import httpClient from 'utils/httpClient/httpClient';

export const getDashboardData = (): Promise<AxiosResponse<DashboardData>> => {
  return httpClient.get(API.ADMIN_SERVICE.DASHBOARD);
};

export const inviteNewPageEditor = (editorEmail: string): Promise<AxiosResponse> => {
  const data = {user: {email: editorEmail}};

  return httpClient.post(API.ADMIN_SERVICE.INVITATION, data);
};

export const acceptInvitation = (data: AcceptInvitationDTO): Promise<AxiosResponse<string>> => {
  const {password, passwordConfirmation, nickname, invitationToken} = data;

  const invitationData = {
    user: {password, password_confirmation: passwordConfirmation, nickname, invitation_token: invitationToken},
  };

  return httpClient.put(API.ADMIN_SERVICE.INVITATION, invitationData);
};

export const getUsers = (): Promise<AxiosResponse<ApiData<User[]>>> => {
  return httpClient.get(API.ADMIN_SERVICE.USERS);
};
